import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { authMiddleware } from './helpers/authorization'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.headers['Accept'] = 'application/json'

// initialize authentication middleware
authMiddleware(store, router)

new Vue({
  router,
  store,
  data: () => ({ drawerIsActive: true }),
  render: h => h(App)
}).$mount('#app')
